import _asyncToGenerator from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/regenerator/index.js";
import { WINDOW } from '../constants.js';
import { createPerformanceSpans } from './createPerformanceSpans.js';

/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */
function addMemoryEntry(_x) {
  return _addMemoryEntry.apply(this, arguments);
}
function _addMemoryEntry() {
  _addMemoryEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(replay) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            return _context.abrupt("return", Promise.all(createPerformanceSpans(replay, [
            // @ts-ignore memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            createMemoryEntry(WINDOW.performance.memory)])));
          case 4:
            _context.prev = 4;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", []);
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 4]]);
  }));
  return _addMemoryEntry.apply(this, arguments);
}
function createMemoryEntry(memoryEntry) {
  var jsHeapSizeLimit = memoryEntry.jsHeapSizeLimit,
    totalJSHeapSize = memoryEntry.totalJSHeapSize,
    usedJSHeapSize = memoryEntry.usedJSHeapSize;
  // we don't want to use `getAbsoluteTime` because it adds the event time to the
  // time origin, so we get the current timestamp instead
  var time = new Date().getTime() / 1000;
  return {
    type: 'memory',
    name: 'memory',
    start: time,
    end: time,
    data: {
      memory: {
        jsHeapSizeLimit: jsHeapSizeLimit,
        totalJSHeapSize: totalJSHeapSize,
        usedJSHeapSize: usedJSHeapSize
      }
    }
  };
}
export { addMemoryEntry };